module.exports = __webpack_public_path__ + "img/20180815_151230_129.e3324ce9.jpg";